export class FuncionarioModel {

    constructor(
        public numeroIdFuncionario: string, public tipoIdFuncionario: string
    ) {

    }
}

export class FuncionarioListasModel{
    constructor(
        public tipoIdFuncionario: string,
        public numeroIdFuncionario: string,
        public nombreCompleto: string
    ) {

    }

}

export class FuncionarioBasicoModel {
    tipoIdFuncionario: string;
    numeroIdFuncionario: string;
    dependencia: string;
    idSia3: string;
    sede: string;
    nombreCompleto: string;
    primerNombre?: string;
    segundoNombre?: string;
    primerApellido?: string;
    segundoApellido?: string;
    tipoFuncionario: string;

}
